module.exports = __webpack_public_path__ + "img/social-3.56687450.png";